<template>
  <div id="app" v-if="activityInfo">
    <keep-alive>
      <router-view v-if="$route.meta && $route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!($route.meta && $route.meta.keepAlive)" />
    <portal-target name="nf-dialog"></portal-target>
    <Loading></Loading>
    <Toast></Toast>
    <OpenApp />
  </div>
</template>

<script>
import Toast from './components/Toast'
import Loading from './components/Loading'
import OpenApp from './components/OpenApp'
import getParamsFromUrl from '@/utils/getParamsFromUrl'
import { mapActions, mapMutations, mapGetters } from 'vuex'
import { getActivityInfo, activityVisitor } from '@/server/interfaces'
import setDocuemntTtitle from '@/utils/setDocumentTitle'
import { initShare } from '@/utils/share'
import { cityList } from './utils/cityList'

export default {
  name: 'app',
  components: {
    Toast,
    Loading,
    OpenApp
  },
  computed: {
    ...mapGetters({
      activityId: 'activityInfo/activityId',
      activityInfo: 'activityInfo/activityInfo'
    })
  },
  methods: {
    ...mapMutations({
      setActivityId: 'activityInfo/setActivityId',
      setActivityInfo: 'activityInfo/setActivityInfo',
      toast: 'toast/showToast',
      showLoading: 'loading/showLoading',
      hideLoading: 'loading/hideLoading',
      setShareInfo: 'activityInfo/setShareInfo',
      setSelectedCity: 'home/setSelectedCity',
      setSelectCateList: 'home/setSelectCateList'
    }),
    ...mapActions({
      getSystemInfo: 'getSystemInfo',
      getUserInfo: 'userInfo/getUserInfo',
      initNfPluseShare: 'activityInfo/initNfPluseShare',
      getWxUserInfo: 'userInfo/getWxUserInfo'
    }),
    redirectRoute ({ routeName }) {
      this.$router.replace({ name: routeName })
    },
    getUrlParams () {
      const params = getParamsFromUrl()
      if (params.id) {
        this.setActivityId(params.id)
      }
    },
    async init () {
      this.getUrlParams()
      await this.getSystemInfo()
      await this.getWxUserInfo()
      activityVisitor({ activityId: this.activityId })
      this.showLoading()
      try {
        const detailRes = await getActivityInfo({
          params: {
            id: this.activityId
          }
        })
        console.log('本次活动信息：', detailRes)
        if (detailRes) {
          if (detailRes.entryShow) {
            const cityName = detailRes.entryShow.dimension === 'CITY' ? detailRes.entryShow.city : detailRes.entryShow.province
            cityList.forEach(item => {
              if (cityName === item.value) {
                this.setSelectedCity({ ...item, district: detailRes.entryShow.district, districtCode: detailRes.entryShow.districtCode })
              }
            })
          }
          this.setActivityInfo(detailRes)
          this.setShareInfo({
            title: this.activityInfo.share.shareTitle,
            desc: this.activityInfo.share.shareDesc,
            link: window.location.href,
            imgUrl: this.activityInfo.share.shareIcon
          })
          try {
            this.initNfPluseShare()
          } catch (e) {
            window.console.log(e)
          }
          try {
            initShare({
              shareTitle: detailRes.share.shareTitle,
              shareUrl: window.location.href,
              shareIcon: detailRes.share.shareIcon,
              shareDesc: detailRes.share.shareDesc
            })
          } catch (e) {
            window.console.log(e)
          }
          setDocuemntTtitle(detailRes.name)
        } else {
          this.toast('活动信息获取失败')
          console.log('1 活动信息获取失败')
          this.hideLoading()
          this.$router.replace('/nothingnessActivity')
        }
      } catch (e) {
        this.toast('活动信息获取失败')
        console.log('2 活动信息获取失败', e)
        this.hideLoading()
        this.$router.replace('/nothingnessActivity')
      }
    }
  },
  created () {
    this.init()
  }
}
</script>

<style lang="scss">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  background: #f5f4f4;
  .amap-logo {
    display: none;
  }
  .amap-copyright {
    opacity: 0;
  }
}
</style>
